var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2857 34.6667H43.0952C46.781 34.6667 49.7619 31.6857 49.7619 28C49.7619 24.3143 46.781 21.3333 43.0952 21.3333C42.3905 21.3333 41.7048 21.4476 41.0667 21.6476C41.1429 21.2381 41.1905 20.8095 41.1905 20.381C41.1905 16.6952 38.2095 13.7143 34.5238 13.7143C32.8572 13.7143 31.3429 14.3333 30.1714 15.3429C28.8762 11.6286 25.3429 8.95239 21.1905 8.95239C15.9333 8.95239 11.6667 13.2191 11.6667 18.4762C11.6667 19.4762 11.8286 20.4476 12.1143 21.3524C8.6762 21.6191 5.96191 24.4857 5.96191 27.9905C5.96191 31.6762 8.94287 34.6572 12.6286 34.6572H15.4857",
    stroke: "#0068B5",
    strokeWidth: 1.90476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1045 21.3524C12.2759 21.3429 12.4473 21.3334 12.6188 21.3334C13.914 21.3334 15.114 21.7048 16.1426 22.3334",
    stroke: "#0068B5",
    strokeWidth: 1.90476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1904 15.3334C30.438 16.0286 30.6 16.7619 30.6761 17.5239",
    stroke: "#0068B5",
    strokeWidth: 1.90476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0664 21.6476C40.914 22.4285 40.6283 23.1619 40.2378 23.8095",
    stroke: "#0068B5",
    strokeWidth: 1.90476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5237 40.381H20.238C18.66 40.381 17.3809 41.6602 17.3809 43.2381V44.1905C17.3809 45.7685 18.66 47.0476 20.238 47.0476H34.5237C36.1017 47.0476 37.3809 45.7685 37.3809 44.1905V43.2381C37.3809 41.6602 36.1017 40.381 34.5237 40.381Z",
    stroke: "#0068B5",
    strokeWidth: 1.90476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5237 33.7142H20.238C18.66 33.7142 17.3809 34.9934 17.3809 36.5714V37.5238C17.3809 39.1017 18.66 40.3809 20.238 40.3809H34.5237C36.1017 40.3809 37.3809 39.1017 37.3809 37.5238V36.5714C37.3809 34.9934 36.1017 33.7142 34.5237 33.7142Z",
    stroke: "#0068B5",
    strokeWidth: 1.90476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5237 27.0476H20.238C18.66 27.0476 17.3809 28.3268 17.3809 29.9048V30.8571C17.3809 32.4351 18.66 33.7143 20.238 33.7143H34.5237C36.1017 33.7143 37.3809 32.4351 37.3809 30.8571V29.9048C37.3809 28.3268 36.1017 27.0476 34.5237 27.0476Z",
    stroke: "#0068B5",
    strokeWidth: 1.90476,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.7143,
    height: 40,
    fill: "white",
    transform: "translate(5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon_cloud.bed1397da40f581e41c248ad871641c5.svg";
export { ForwardRef as ReactComponent };